import { headers }  from '@utils/utils';

const usefaqStore = defineStore('faq', () => {

  // state
  const faq = ref({
    id        : null,
    pregunta  : "",
    respuesta : "",
    roles     : [],
    aprobada  : true,
    usuario_id: null,
    usuario   : null
  });

  const faqs = ref([]);


  // getters
  const draft = computed(() => clone(faq.value));

  // methods
  const setFaq = (data) => {
    faq.value = data;
  };

  const setFaqs = (faqs) => {
    faqs.value = faqs;
  };

  const clear = () => {
    faq.value = {
      id: null,
      pregunta: "",
      respuesta: "",
      roles: [],
      aprobada: true,
      usuario_id: null,
      usuario: null,
    };
  };

  // methods actions

  const fetch = async (faq_id) => {
    try {
      const {data} = await axios.get(`/api/faqs/${faq_id}/fetch-data`);
      
      if(data.id){
        setFaq(data);
      }

      return data;
    } catch (error) {
      console.log("Error fetching faq:", error);    

      throw error;
    }
  };


  const fetchData = (params) => {
    return new Promise((resolve,reject) => {
      axios.post(`/api/faqs/fetch-data`,params)
      .then(({data}) => resolve(data))
      .catch((e) => reject(e)); 
    })
  };

  const guardar = (datos) => {
   
    return new Promise((resolve, reject) => {
      if(datos.id){
        
        axios.put(`/api/faqs/${datos.id}`,datos)
        .then(({data}) => {
          resolve(data);
        })
        .catch(e => reject(e));

      }else{
        axios.post(`/api/faqs`,datos)
        .then(({data}) => {
          resolve(data);
        })
        .catch(e => reject(e));
      }
    });
   
  };

  const eliminar = (faq_id) => {

    return new Promise((resolve, reject) => {
      axios.delete(`/api/faqs/${faq_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const cambiarEstatus = (aprobada, faq_id) => {
    return new Promise((resolve, reject) => {
      axios.put(`/api/faqs/${faq_id}/cambiar-estatus`, { aprobada })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };


  return {
    faq,
    faqs,
    draft,
    // methods
    setFaq,
    setFaqs,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    cambiarEstatus,
  };
  
});


export default usefaqStore;